import {
    ERROR,
    GET_SINGLE_TVR_APPLICATION,
    GET_TVR_APPLICATIONS,
    LOADER,
    SET_CURRENT_TVR_APPLICATION_ID,
} from "../actionType";

let initialState = {
    loading: false,
    error: null,
    tvrApplications: [],
    singleTVRApplication: null,
    currentTVRId: null,
};

export const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case LOADER:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case ERROR:
            return {
                ...state,
                loading: false,
                error: payload,
            };
        case GET_SINGLE_TVR_APPLICATION:
            return {
                ...state,
                loading: false,
                singleTVRApplication: payload,
                error: null,
            };
        case GET_TVR_APPLICATIONS:
            return {
                ...state,
                loading: false,
                tvrApplications: { data: [...payload.applications], pagination: payload.pagination },
                error: null,
            };
        case SET_CURRENT_TVR_APPLICATION_ID:
            return { ...state, currentTVRId: payload };
        default:
            return state;
    }
};